// Mock data for SmartShieldGlobal website

export const companyInfo = {
  name: "SmartShieldGlobal",
  tagline: "Architecting The Secure Ecosystem",
  logo: "https://smartshieldglobal.com/logo.png",
  description: "Leading AI solutions provider transforming Financial Services, Healthcare, and Education sectors with cutting-edge artificial intelligence.",
  email: "info@smartshieldglobal.ai",
  phone: "+966 538393459",
  address: "Kingdom of Saudi Arabia",
  website: "smartshieldglobal.ai",
  social: {
    linkedin: "https://www.linkedin.com/company/smartshieldglobal",
    twitter: "https://twitter.com/smartshieldglobal",
    facebook: "https://www.facebook.com/smartshieldglobal"
  }
};

export const services = [
  {
    id: 1,
    sector: "Financial",
    icon: "TrendingUp",
    title: "AI-Powered Financial Intelligence",
    description: "Transform your financial operations with predictive analytics, fraud detection, and automated risk assessment.",
    features: [
      "Real-time Fraud Detection",
      "Algorithmic Trading Systems",
      "Risk Assessment & Compliance",
      "Customer Behavior Analytics",
      "Portfolio Optimization"
    ],
    benefits: "Reduce operational costs by 40% while improving accuracy and security"
  },
  {
    id: 2,
    sector: "Healthcare",
    icon: "Heart",
    title: "Healthcare AI Solutions",
    description: "Revolutionize patient care with AI-driven diagnostics, personalized treatment plans, and operational efficiency.",
    features: [
      "AI Diagnostic Assistance",
      "Predictive Patient Analytics",
      "Medical Image Analysis",
      "Drug Discovery Acceleration",
      "Healthcare Operations Optimization"
    ],
    benefits: "Improve patient outcomes by 35% and reduce diagnosis time significantly"
  },
  {
    id: 3,
    sector: "Education",
    icon: "GraduationCap",
    title: "Intelligent Education Systems",
    description: "Empower learners with personalized AI tutoring, adaptive learning paths, and comprehensive analytics.",
    features: [
      "Personalized Learning Paths",
      "AI-Powered Tutoring",
      "Student Performance Analytics",
      "Automated Grading Systems",
      "Content Recommendation Engine"
    ],
    benefits: "Increase student engagement by 50% with personalized learning experiences"
  }
];

export const projects = [
  {
    id: 1,
    title: "Global Bank Fraud Detection System",
    sector: "Financial",
    description: "Implemented AI-powered fraud detection system processing 10M+ transactions daily with 99.7% accuracy.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80",
    results: ["99.7% Detection Accuracy", "$50M+ Fraud Prevented", "Real-time Processing"],
    tech: ["Machine Learning", "Deep Learning", "Big Data Analytics"]
  },
  {
    id: 2,
    title: "AI Diagnostic Platform for Radiology",
    sector: "Healthcare",
    description: "Developed AI assistant for radiologists, reducing diagnosis time by 60% while maintaining 98% accuracy.",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80",
    results: ["60% Faster Diagnosis", "98% Accuracy Rate", "500K+ Scans Analyzed"],
    tech: ["Computer Vision", "Neural Networks", "Medical AI"]
  },
  {
    id: 3,
    title: "Adaptive Learning Platform",
    sector: "Education",
    description: "Created personalized learning system serving 100K+ students with adaptive curriculum and real-time feedback.",
    image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&q=80",
    results: ["100K+ Active Students", "45% Performance Improvement", "85% Engagement Rate"],
    tech: ["Natural Language Processing", "Recommendation Systems", "Learning Analytics"]
  },
  {
    id: 4,
    title: "Risk Assessment AI for Insurance",
    sector: "Financial",
    description: "Built comprehensive risk evaluation system using AI to assess and predict insurance claims with unprecedented accuracy.",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
    results: ["35% Cost Reduction", "92% Prediction Accuracy", "Automated Processing"],
    tech: ["Predictive Analytics", "Risk Modeling", "Data Science"]
  },
  {
    id: 5,
    title: "Patient Care Optimization System",
    sector: "Healthcare",
    description: "Deployed AI system optimizing hospital operations, patient flow, and resource allocation across 50+ facilities.",
    image: "https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=800&q=80",
    results: ["30% Efficiency Gain", "50+ Hospitals", "Better Patient Experience"],
    tech: ["Operations Research", "AI Optimization", "Healthcare Analytics"]
  },
  {
    id: 6,
    title: "Smart Campus Management",
    sector: "Education",
    description: "Integrated AI-powered campus management system covering attendance, security, and resource optimization.",
    image: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=800&q=80",
    results: ["20+ Institutions", "40% Resource Optimization", "Enhanced Security"],
    tech: ["IoT Integration", "Smart Systems", "AI Automation"]
  }
];

export const team = [
  {
    id: 1,
    name: "Dr. Sarah Chen",
    role: "Chief AI Officer",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&q=80",
    bio: "15+ years in AI research and implementation across Fortune 500 companies."
  },
  {
    id: 2,
    name: "Michael Rodriguez",
    role: "Head of Financial AI",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80",
    bio: "Former Goldman Sachs AI lead, specializing in algorithmic trading and risk analysis."
  },
  {
    id: 3,
    name: "Dr. Priya Patel",
    role: "Healthcare AI Director",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&q=80",
    bio: "Medical doctor and AI researcher with 20+ published papers on diagnostic AI."
  },
  {
    id: 4,
    name: "James Williams",
    role: "Education Solutions Lead",
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&q=80",
    bio: "EdTech pioneer with successful AI learning platforms serving millions of students."
  }
];

export const stats = [
  { label: "AI Projects Delivered", value: "500+" },
  { label: "Industries Served", value: "3" },
  { label: "Client Satisfaction", value: "98%" },
  { label: "Years of Excellence", value: "10+" }
];

export const testimonials = [
  {
    id: 1,
    name: "John Anderson",
    role: "CTO, Global Finance Corp",
    content: "SmartShieldGlobal's AI solution transformed our fraud detection capabilities. We've prevented millions in losses while improving customer experience.",
    rating: 5
  },
  {
    id: 2,
    name: "Dr. Emily White",
    role: "Chief Medical Officer, HealthCare Plus",
    content: "The diagnostic AI platform has been a game-changer for our radiology department. Faster, more accurate, and our doctors love it.",
    rating: 5
  },
  {
    id: 3,
    name: "Robert Taylor",
    role: "Dean, National University",
    content: "The adaptive learning system has dramatically improved student outcomes. Personalized education at scale is now a reality.",
    rating: 5
  }
];